import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from './new-internet.model';
import { NewInternetService, DiscoverResult } from './new-internet.service';

@Component({
    selector: 'app-ni-subscriptions',
    templateUrl: './subscriptions.component.html',
    styleUrls: ['./subscriptions.component.scss'],
    standalone: false
})
export class SubscriptionsComponent {
  @Input() subscriptions: Subscription[] = [];
  @Input() errors: { [feedUrl: string]: string } = {};
  @Input() unreadByFeed: { [feedUrl: string]: number } = {};
  @Output() add = new EventEmitter<Omit<Subscription, 'id'>>();
  @Output() remove = new EventEmitter<string>();

  urlInput = '';
  busy = false;
  message = '';
  pending: DiscoverResult | null = null;

  constructor(private svc: NewInternetService) {}

  async discover(): Promise<void> {
    const url = this.urlInput.trim();
    if (!url) { return; }
    this.busy = true;
    this.message = '';
    this.pending = null;
    try {
      this.pending = await this.svc.discover(url);
    } catch (e: any) {
      this.message = (e && e.message) || 'Could not find a feed there.';
    } finally {
      this.busy = false;
    }
  }

  confirm(): void {
    if (!this.pending) { return; }
    this.add.emit({
      title: this.pending.title,
      feedUrl: this.pending.feedUrl,
      siteUrl: this.pending.siteUrl,
      type: this.pending.type,
      addedAt: Date.now(),
    });
    this.pending = null;
    this.urlInput = '';
    this.message = 'Added.';
  }

  cancel(): void {
    this.pending = null;
  }
}
